module.exports = __webpack_public_path__ + "static/media/Sly.c9fd0aac.jpg";